import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import { cleanSpecialCharacters } from "../../../../extras";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import React from "react";
import { formatFinance } from "../../../../utils/formatters";

const DeliveryStats = ({ data, loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <DeliveryDiningIcon sx={{ mr: 1, color: "success.main" }} />
        <Typography variant="h6">Delivery</Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Faturamento
          </Typography>
          <Typography variant="h5">{formatFinance(data.totalSales)}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Ticket Médio
          </Typography>
          <Typography variant="h5">
            {formatFinance(data.averageOrder)}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Pedidos
          </Typography>
          <Typography variant="h5">
            {data.orderCount.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            vs. Período Anterior
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h5"
              sx={{
                color: data.percentChange >= 0 ? "success.main" : "error.main",
              }}
            >
              {data.percentChange.toFixed(1)}%
            </Typography>
            {data.percentChange >= 0 ? (
              <TrendingUpIcon sx={{ ml: 0.5, color: "success.main" }} />
            ) : (
              <TrendingDownIcon sx={{ ml: 0.5, color: "error.main" }} />
            )}
          </Box>
        </Grid>
      </Grid>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Por Plataforma
      </Typography>

      <Box sx={{ height: 180 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data.platformDistribution}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            layout="vertical"
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" domain={[0, 100]} />
            <YAxis
              type="category"
              dataKey="name"
              tick={(props) => {
                const { x, y, payload } = props;
                return (
                  <g transform={`translate(${x},${y})`}>
                    <text x={-25} y={4} textAnchor="end" fill="#666">
                      {cleanSpecialCharacters(payload.value)}
                    </text>
                  </g>
                );
              }}
            />
            <Tooltip
              formatter={(value) => [`${value.toFixed(1)}%`, "Porcentagem"]}
            />
            <Bar dataKey="value" fill="#82ca9d" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
};

export default DeliveryStats;
